import {getUser} from '../../../service/service'
export default {
  name:'index',
  data: function() {
    return {
      pageTo: '',
      typeHover: '',
      token: '',
      userInfo: {}
    }
  },
  methods: {
    mouseOver(type){
      this.typeHover = type
    },
    mouseLeave(){
      this.typeHover = ''
    },
    clickNav(type){
      if(type !== this.pageTo){
        this.$router.push({
          name: type
        })
      }
      this.pageTo = type
    },

    loginOut(){
      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      window.location.reload()
    }
  },
  beforeMount(){
    this.pageTo = this.$route.name
  },

  created(){

  },
  mounted(){
    this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
    let p = {
      UserUID: this.token
    }
    getUser(p).then(res=>{
      console.log(res)
      this.userInfo = res.User
      sessionStorage.setItem('userName',res.User.Name)
      localStorage.setItem('userName',res.User.Name)
      // if(res.Success){
      //   this.userInfo = res.User
      // }
    })
  }
}
